import Uploader from 'html5-uploader';
import notification from 'notification-js';
import Config from 'config';
var _URL = window.URL || window.webkitURL;
export default function(uploadId, image, onImageSave, validation) {
  let uploader = new Uploader({
    el: "#" + uploadId,
    url: Config.IMAGE_UPLOAD,
    headers: {"AUTH-TOKEN": Config.authToken}
  });

  uploader.on('upload:done', (response) => {
    var res = JSON.parse(response);
    if (image) image.src = res.path;
    onImageSave(res.path);
  });

  uploader.on('error', function(err) {
    alert(err);
  });

  uploader.on('files:added', (files) => {
    if (validation && validation.ratio && validation.size.minWidth) {
      var img = new Image;

      img.onload = function() {
        var errors = false;
        if (validation.size && validation.size.minWidth) {
          if (img.width < validation.size.minWidth) {
            uploadError("The image width is too small please ensure it's at least " + validation.size.minWidth + "px");
            errors = true;
          }
        }

        if (validation.ratio && validation.ratio == "16:9") {
          var heightShouldEqual = Math.round(img.width * (9/16));
          if (img.height !== heightShouldEqual) {
            uploadError("The image ratio should be 16:9");
            errors = true;
          }
        }

        if (!errors) {
          uploader.upload();
        } else {
          return false;
        }
      };
      img.src = _URL.createObjectURL(files[0]);
    } else {
      uploader.upload();
    }

  });

  function uploadError(message) {
    notification.notify( 'error', message, {
      notification: {position: [ 'right', 'top' ]}
    });
  }
}



// WEBPACK FOOTER //
// ./src/editors/ImageUpload.js